import { useEffect, useEffectEvent } from 'react';

const useInterval = (callback: () => void, delay: number | null) => {
  const onTick = useEffectEvent(callback);

  useEffect(() => {
    if (delay === null) return;

    const id = setInterval(() => onTick(), delay);

    return () => clearInterval(id);
  }, [delay]);
};

export default useInterval;
